import { useState, useEffect, useRef, useMemo } from 'react'

import Icon from '../components/Icon'

interface TagType {
  id: number
  title: string
}

const Tag = ({ title, onRemove }: any) => {
  return (
    <span className="flex items-center rounded text-white text-sm align-middle bg-lime-300 p-1 mx-px">
      {title}
      <span
        className="text-sm"
        onClick={(e) => {
          onRemove && onRemove(title)
        }}
      >
        <Icon name="clear" className="text-base cursor-pointer" />
      </span>
    </span>
  )
}

const TagsInput = ({
  name,
  value: initTags = [],
  placeholder,
  limit = 1,
  onChange = (tags: string[], name: string) => {},
  validator,
  converter,
}: {
  name: string
  value: string[]
  placeholder?: string
  limit: number
  onChange: (tags: string[], name: string) => void
  validator?: (value: string) => boolean
  converter?: (value: string) => string | null
}) => {
  const [tags, setTags] = useState<Array<string>>(initTags)
  const [filter, setFilter] = useState<string>('')

  useEffect(() => {
    setTags(initTags)
  }, [initTags])

  const handleRemove = (title: string) => {
    const _tags = tags.filter((tag: string) => tag !== title)
    onChange(_tags, name)
  }

  const handleChangeFilter = (e: any) => {
    const value = e.target.value
    setFilter(value)
  }

  const handleKeyDown = (e: any) => {
    if (e.key === 'Backspace') {
      if ((!filter || filter.length === 0) && tags.length > 0) {
        const _tags = tags.slice(0, -1)
        onChange(_tags, name)
      }
    }

    if (e.key === 'Enter') {
      const value = converter ? converter(e.target.value) : e.target.value
      if (!value) return

      const _tags = tags.concat(value)
      setFilter('')
      onChange(_tags, name)
    }
  }

  return (
    <div className="inline-block">
      <div className="flex flex-auto border rounded-md bg-white dark:bg-gray-600 p-1">
        {tags.map((tag: string) => (
          <Tag title={tag} onRemove={handleRemove} />
        ))}
        <input
          className="flex flex-auto px-0 py-1 mx-1 overflow-x-auto shadow-none outline-none dark:bg-gray-600"
          style={{ width: '1%' }}
          value={filter}
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          onChange={handleChangeFilter}
        />
      </div>
    </div>
  )
}

export default TagsInput
